import { render, staticRenderFns } from "./SlotsView.vue?vue&type=template&id=4d9b019e&scoped=true"
import script from "./SlotsView.vue?vue&type=script&lang=js"
export * from "./SlotsView.vue?vue&type=script&lang=js"
import style0 from "./SlotsView.vue?vue&type=style&index=0&id=4d9b019e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9b019e",
  null
  
)

export default component.exports